import type { KeyboardEvent } from 'react'

// Disabling the focused field can put focus on body, bypassing dialog key handlers.
export function restoreDialogFocus(dialog: HTMLDialogElement | null) {
  if (!dialog?.open) return
  const active = document.activeElement
  const owner = active?.closest('dialog[open]')
  if (owner && owner !== dialog) return
  if (!dialog.contains(active) || active?.matches(':disabled')) dialog.querySelector<HTMLElement>('button:not(:disabled)')?.focus()
}

// Native modality owns navigation; retain Tab boundaries and caller-owned dismissal.
export function handleDialogKeyDown(event: KeyboardEvent<HTMLDialogElement>, onClose: () => void) {
  if (event.defaultPrevented || (event.target as Element).closest('dialog') !== event.currentTarget) return
  if (event.key === 'Escape' || event.key === 'Esc') {
    // Native Escape cancel can be non-cancelable; prevent the keyboard default first.
    event.preventDefault()
    event.stopPropagation()
    if (!event.repeat) onClose()
    return
  }
  if (event.key !== 'Tab') return
  const root = event.currentTarget.contains(document.fullscreenElement) ? document.fullscreenElement! : event.currentTarget
  const items = [...root.querySelectorAll<HTMLElement>('button,input,select,textarea,a[href],summary,[tabindex]')]
    .filter(element => element.tabIndex >= 0 && !element.matches(':disabled') && !element.closest('[hidden], [inert]') && getComputedStyle(element).visibility !== 'hidden' && element.getClientRects().length)
  const first = items[0]
  const last = items.at(-1)
  const target = event.shiftKey && document.activeElement === first ? last :
    !event.shiftKey && document.activeElement === last ? first : undefined
  if (target) { event.preventDefault(); target.focus() }
}
